import { createContext } from 'react';
import { GlobalContext } from 'src/PollEntrypointLoader';
import { TEMPLATE_POLL } from '../constants';

export const RootContext = createContext<GlobalContext>({
  trackingEngine: null as never,
  schemaEngine: null as never,
  template: TEMPLATE_POLL, // TODO: replace useContext(RootContext) with safe version and remove default value
  theme: undefined as never,
  prefersColorScheme: 'light',
});
